import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import sum from 'lodash-es/sum';

export interface IElementHeightEntry {
    state: BehaviorSubject<number | undefined>;
    options?: IElementHeightEntryOptions;
}

export interface IElementHeightEntryOptions {
    /**
     * Element that has topOffset flag will be considered as one that may be covering content
     * when scrolling to a content element its height will be added to scroll offset
     */
    topOffset: boolean;

    /**
     * In local mode variable is only set on the element
     */
    local?: boolean;

    resizeDebounceTime?: number;
}

@Injectable({
    providedIn: 'root'
})
export class ElementHeightService {
    /**
     * Subjects with states
     */
    private items: { [key: string]: IElementHeightEntry } = {};

    register(key: string, options?: IElementHeightEntryOptions) {
        if (!this.items[key]) {
            this.items[key] = {
                state: new BehaviorSubject<number | undefined>(undefined)
            };
        }
        this.items[key].options = options;
    }

    getState(key: string) {
        if (!this.items[key]) {
            this.register(key);
        }
        return this.items[key].state;
    }

    /**
     * Calculates top element offset (header etc) that we need to take as an offset when scrolling to an element
     */
    getTopOffset(): number {
        return sum(
            Object.values(this.items)
                .filter(i => i.options?.topOffset)
                .map(i => i.state.value || 0)
        );
    }
}
